var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _rect9, _path3, _rect0, _rect1, _rect10, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 417,
    height: 363,
    viewBox: "0 0 417 363",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.4585,
    y: 195.098,
    width: 202.975,
    height: 46.9025,
    rx: 6.46931,
    fill: "white",
    fillOpacity: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.6317,
    y: 207.228,
    width: 142.325,
    height: 8.08664,
    rx: 4.04332,
    fill: "#C8D2E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65.6317,
    y: 221.783,
    width: 88.9531,
    height: 8.08664,
    rx: 4.04332,
    fill: "#C8D2E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49.4585,
    y: 254.13,
    width: 202.975,
    height: 46.9025,
    rx: 6.46931,
    fill: "white",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 65.6317,
    y: 266.26,
    width: 142.325,
    height: 8.08664,
    rx: 4.04332,
    fill: "#C8D2E9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 65.6317,
    y: 280.816,
    width: 88.9531,
    height: 8.08664,
    rx: 4.04332,
    fill: "#C8D2E9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 49.4585,
    y: 313.163,
    width: 202.975,
    height: 46.9025,
    rx: 6.46931,
    fill: "white",
    fillOpacity: 0.25
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 22.7725,
    y: 40.6425,
    width: 255.538,
    height: 420.505,
    rx: 35.5812,
    stroke: "#C8D2E9",
    strokeWidth: 9.70397
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7906 54C7.95495 54 0 61.9549 0 71.7906C0 76.2129 1.27076 80.3555 3.58354 84.0916C5.99798 88.0055 9.17487 91.3603 11.6147 95.2742C12.8092 97.1804 13.6734 98.9594 14.5883 101.018C15.2491 102.416 15.7828 104.83 17.7906 104.83C19.7984 104.83 20.3321 102.416 20.9675 101.018C21.9079 98.9594 22.7466 97.1804 23.9411 95.2742C26.3809 91.3857 29.5578 88.0309 31.9723 84.0916C34.3105 80.3555 35.5812 76.2129 35.5812 71.7906C35.5812 61.9549 27.6263 54 17.7906 54Z",
    fill: "#12323F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4368 72.4261C11.4368 75.9333 14.2833 78.7798 17.7906 78.7798C21.2979 78.7798 24.1443 75.9333 24.1443 72.4261C24.1443 68.9188 21.2979 66.0723 17.7906 66.0723C14.2833 66.0723 11.4368 68.9188 11.4368 72.4261Z",
    fill: "#8CD1F5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 94.7437,
    y: 39.0254,
    width: 111.596,
    height: 21.8339,
    rx: 6.46931,
    fill: "#C8D2E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 80.2364C102.033 56.8657 227.173 44.9198 303.469 184.101",
    stroke: "#8CD1F5",
    strokeWidth: 1.61733,
    strokeDasharray: "4.85 4.85"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 49.4585,
    y: 136.065,
    width: 202.975,
    height: 46.9025,
    rx: 6.46931,
    fill: "#12323F"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 65.6317,
    y: 148.195,
    width: 142.325,
    height: 8.08664,
    rx: 4.04332,
    fill: "#8CD1F5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 65.6317,
    y: 162.751,
    width: 88.9531,
    height: 8.08664,
    rx: 4.04332,
    fill: "#8CD1F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M229.925 165.703L236.256 159.516L229.925 153.33L231.875 151.43L240.168 159.516L231.875 167.603L229.925 165.703Z",
    fill: "#448199"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M380.63 203.732C377.973 190.131 366.13 179.92 351.903 179.92C340.607 179.92 330.796 186.386 325.911 195.847C314.146 197.109 305 207.161 305 219.343C305 232.392 315.514 242.996 328.451 242.996H379.262C390.05 242.996 398.805 234.166 398.805 223.285C398.805 212.878 390.793 204.441 380.63 203.732Z",
    fill: "#C8D2E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M409.575 164.548C408.612 159.665 404.324 156 399.173 156C395.083 156 391.531 158.321 389.762 161.717C385.503 162.17 382.191 165.779 382.191 170.152C382.191 174.836 385.998 178.643 390.682 178.643H409.079C412.985 178.643 416.155 175.473 416.155 171.567C416.155 167.831 413.254 164.802 409.575 164.548Z",
    fill: "#C8D2E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M362.9 203.666H361.526V200.946H358.776V203.666H345.029V200.946H342.279V203.666H340.905C339.392 203.666 338.155 204.89 338.155 206.386V228.146C338.155 229.642 339.392 230.866 340.905 230.866H362.9C364.412 230.866 365.65 229.642 365.65 228.146V206.386C365.65 204.89 364.412 203.666 362.9 203.666ZM362.9 228.146H340.905V210.466H362.9V228.146Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M351.549 222.611V224.032H345.256V222.819L348.232 219.629C348.531 219.296 348.767 219.003 348.939 218.751C349.112 218.494 349.236 218.264 349.312 218.062C349.392 217.856 349.432 217.66 349.432 217.474C349.432 217.196 349.386 216.959 349.293 216.761C349.201 216.558 349.064 216.403 348.883 216.293C348.706 216.184 348.487 216.129 348.226 216.129C347.948 216.129 347.708 216.196 347.505 216.331C347.307 216.466 347.156 216.653 347.051 216.893C346.949 217.133 346.899 217.405 346.899 217.708H345.073C345.073 217.161 345.204 216.659 345.465 216.205C345.726 215.746 346.094 215.381 346.57 215.112C347.046 214.838 347.611 214.701 348.264 214.701C348.908 214.701 349.451 214.806 349.893 215.017C350.34 215.223 350.677 215.522 350.904 215.914C351.136 216.301 351.252 216.765 351.252 217.304C351.252 217.607 351.203 217.904 351.106 218.195C351.01 218.481 350.871 218.767 350.689 219.054C350.513 219.336 350.298 219.622 350.045 219.913C349.792 220.204 349.512 220.505 349.205 220.817L347.606 222.611H351.549ZM359.13 220.595V222.023H352.503L352.414 220.918L356.249 214.834H357.696L356.129 217.456L354.221 220.595H359.13ZM358.088 214.834V224.032H356.268V214.834H358.088Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppBg);
export default __webpack_public_path__ + "static/media/app-bg.ee8b1c6c472738d039d6250b6613c3aa.svg";
export { ForwardRef as ReactComponent };